define('app/views/gift_message_view',['app/setup','app/views/gift_message_form_view','app/factories/modal_factory','app/views/modal_view'], function(takhfifan,giftMessageFormView,modelFactory,modalView) {

  takhfifan.GiftMessageView = takhfifan.BaseView.extend({

    isOpen:false,

    events: {
      'click  .checkbox': 'toggleForm'
    },
    initialize: function() {
      this.modalContentFlag = false;
      var _this = this;
      if(this.$el.attr('data-isgiftenabled')=='1') {
        this.toggleForm();
      }
      takhfifan.eventHub.on('modal:disableTriggerElement', function(options) {
        if(options.triggerElement.attr('id') == 'allow_gift_messages') {
          _this.$('#allow_gift_messages').prop('checked', false);
          _this.isOpen=false;
        }
      }, this);
      takhfifan.eventHub.on('modal:closeModalWithContent', function(){
        $('body').removeClass('no-scroll');
      });
      $(".tkh-modal").on("click",function(e){
        if($(e.target).hasClass('tkh-modal')){
          takhfifan.eventHub.trigger('modal:closeModalWithContent');
        }
      });
    },
    toggleForm: function()
    {
      if(this.$('#allow_gift_messages').is(':checked')){
        var template = ( $('#gift-form-template').length > 0 ) ?
        _.template( $('#gift-form-template').html() ) : '';
        if(!this.isOpen)
        {
          this.$('#allow_gift_messages').prop('checked', true);
          if(!this.modalContentFlag){
            $('body').addClass('no-scroll');
            takhfifan.eventHub.trigger('modal:showModalWithContent',
             {
               elementToOperateContent:template(),
               triggerElement:this.$('#allow_gift_messages'),
               fadeTimeIn:400,
               elementToOperate:$('#gift-modal')
             });
            this.modalContentFlag = true;
          }
          else{
            $('body').addClass('no-scroll');
            takhfifan.eventHub.trigger('modal:showModal',
            {
              triggerElement:this.$('#allow_gift_messages'),
              fadeTimeIn:400,
              elementToOperate:$('#gift-modal')
            });
            this.modalContentFlag = true;
          }

          this.isOpen=true;
        }
      }
      else{
        this.$('#allow_gift_messages').prop('checked', false);
        $('.tkh-gift-message').find('.gift-form-result').html('').hide();
        $('.hiddenGiftInput').val('');
      }
    }
  });
});

